export default __webpack_public_path__ + "static/media/key.c9d998a7.pm";